import { render, staticRenderFns } from "./LabElementView.vue?vue&type=template&id=77256986"
import script from "./LabElementView.vue?vue&type=script&lang=js"
export * from "./LabElementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports